import { render, staticRenderFns } from "./ReservationError.vue?vue&type=template&id=0c07d0ec&"
import script from "./ReservationError.vue?vue&type=script&lang=js&"
export * from "./ReservationError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports